import React from 'react';
import '../../styles/onboardingFlow/onboardingComponents/onboardingLogoPanel.scss';
import adupLogoSet from '../../assets/onboarding/common/adup-logo-set.png';

const OnboardingLogoPanel: React.FC = () => {
  return (
    <div className='onboardingLogoPanel'>
      <img
        src={adupLogoSet}
        alt='TARA AdUp'
        className='onboardingLogoPanel__logo'
      />
    </div>
  );
};

export default OnboardingLogoPanel;
